export default __webpack_public_path__ + "static/media/fyc.18d272ce.jpg";